import { Collapse } from "@material-ui/core";
import React, { useEffect } from "react";

import { SiteIssue } from "../../../../dtos/site";
import { SiteIssueType } from "../../../../enums/SiteIssueType";
import { StandardTable } from "../../../shared/table";
import { StatsCountIndicator } from "../StatsCountIndicator";

import { SITE_ISSUE_TYPE_LABELS } from "./consts";

interface Props {
    issueType: SiteIssueType;
    issues: SiteIssue[];
}

export function SiteIssuesTableRow({ issueType, issues }: Props) {
    const [open, setOpen] = React.useState(false);

    useEffect(() => {
        if (issues.length === 0) {
            setOpen(false);
        }
    }, [issues]);

    return (
        <>
            <tr>
                <td style={{ borderBottom: "unset" }}>
                    {SITE_ISSUE_TYPE_LABELS[issueType]}
                </td>
                <td style={{ borderBottom: "unset" }}>
                    <StatsCountIndicator
                        count={issues.length}
                        onClick={() => setOpen(!open)}
                        itemLabel="issue"
                        color={issues.length > 0 ? "secondary" : "primary"}
                    />
                </td>
            </tr>

            <tr>
                <td
                    style={{ padding: 0, margin: 0, borderBottom: open ? "unset" : undefined }}
                    colSpan={2}
                >
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <div>
                            <StandardTable>
                                <tbody>
                                    {issues.map((issue, index) => (
                                        <tr key={index}>
                                            <td style={{ paddingLeft: "40px" }}>
                                                {`${index + 1}. ${issue.description}`}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </StandardTable>
                        </div>
                    </Collapse>
                </td>
            </tr>
        </>
    );
}